import { render, staticRenderFns } from "./TheNavbarHorizontal.vue?vue&type=template&id=4f919360"
import script from "./TheNavbarHorizontal.vue?vue&type=script&lang=js"
export * from "./TheNavbarHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f919360')) {
      api.createRecord('4f919360', component.options)
    } else {
      api.reload('4f919360', component.options)
    }
    module.hot.accept("./TheNavbarHorizontal.vue?vue&type=template&id=4f919360", function () {
      api.rerender('4f919360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/navbar/TheNavbarHorizontal.vue"
export default component.exports